import {
    MDBAlert,
    MDBBtn,
    MDBCheckbox,
    MDBChip,
    MDBCol,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRadio,
    MDBRow,
    MDBSpinner,
    MDBStepper,
    MDBStepperStep,
    MDBTable,
    MDBTableBody,
    MDBTableHead
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

import TNLocalStep1 from './TNLoacalNumbersSteps/TNLocalStep1';
import { useForm } from 'react-hook-form';
import TNCheckList from './TNCheckList';
import UPloadCopyOfBill from './UPloadCopyOfBill';
import SignLOA from './SignLOA';
import TFNSignLOA from './TFNSignLOA';
import { useNavigate } from 'react-router';
import { formatNumber } from 'libphonenumber-js';
import { formattedNumber } from './AddRemoveNumbers';
import { portingStepsForm } from '../../../apiclients/streamsapi_bridge';
import isEqual from "lodash.isequal";
import { getStreamsProductName } from '../../../apiclients/CommonUtils';
import TabIDConstant from '../../../apiclients/TabIDConstant';


function TNLocalNumber(props) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [assignedNumbersDetails, setassignedNumbersDetails] = useState([]);
    const [areaOfServiceDetails, setareaOfServiceDetails] = useState([]);
    const [updateDestinationObj, setUpdateDestinationObj] = useState([]);
    const [updateTempNumObj, setupdateTempNumObj] = useState([]);
    const [updateAllArea, setupdateAllArea] = useState(-1);
    const [destinationTypes, setdestinationTypes] = useState([]);
    const [maxNumFileUpload, setmaxNumFileUpload] = useState(10);
    const [telePhoneList, settelePhoneList] = useState([]);
    const [signLOAUpload, setsignLOAUpload] = useState("");
    const [orderID, setorderID] = useState("");
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [savedDraftData, setsavedDraftData] = useState({});
    const [isChanged, setIsChanged] = useState(false);
    const [currentStepInside, setcurrentStepInside] = useState(1);
    const [deletedFiles, setdeletedFiles] = useState([]);
    const [reloadassigned, setreloadassigned] = useState(false);
    const [portingNumbers, setportingNumbers] = useState([]);
    const [assignedErrors, setassignedErrors] = useState([]);
    const [areaErrors, setAreaErrors] = useState([]);

    const streamsProductName = getStreamsProductName();
    const skipfields = {
        acc_info: {
            // title: "",
            acc_num: "",
            acc_pin: "",
            last_name: "",
            first_name: "",
            company_name: "",
            bill_tele_num: "",
            is_mobile_num: false,
            caller_id_name: "",
            curr_carrier_name: "",
            // name_listed_on_acc: "",
            porting_num_type: 1,

        },
        service_addr: {
            zip: "",
            city: "",
            state: "",
            suite: "",
            floor_num: "",
            street_num: "",
            street_name: "",
            carrier_pin: "",
            carrier_name: "",
            carrier_acc_num: "",
            acc_btn: "",
        }
    };
    const { register, handleSubmit, formState, reset, clearErrors, setValue, getValues, watch, setError, resetField } = useForm({
        defaultValues: {
            enter_num: {
                ddd: "",
                number: "",
            },
            assign: [],
            acc_info: {
                // title: "",
                acc_num: "",
                acc_pin: "",
                last_name: "",
                first_name: "",
                company_name: "",
                bill_tele_num: "",
                is_mobile_num: false,
                caller_id_name: "",
                curr_carrier_name: "",
                // name_listed_on_acc: "",
                porting_num_type: 1,
                contact_title:"",
                authorized_customer_fax: "",

            },
            service_addr: {
                zip: "",
                city: "",
                state: "",
                suite: "",
                floor_num: "",
                street_num: "",
                street_name: "",
                carrier_pin: "",
                carrier_name: "",
                carrier_acc_num: "",
                acc_btn: "",
            },
            area_of_service: [],
            notifs_comments: {
                email: "",
                comments: "",
                contact_ph_num: "",
                send_email_to_admin: true,
            },
            checklist: {
                check_ans_one: true,
                check_ans_two: true,
                check_ans_five: true,
                check_ans_four: true,
                check_ans_three: true,
            },
            sign_loa: {
                consent_flag: false
            }
        }
    })





    const [formValue, setFormValue] = useState({
        fname: 'Mark',
        lname: 'Otto',
        email: '',
        city: '',
        state: '',
        zip: '',
    });

    const onChange = (e) => {
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
    };

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedFiles, setselectedFiles] = useState([]);
    const [uploadedOldFiles, setUploadedOldFiles] = useState([]);
    const [skipFlag, setskipFlag] = useState(0);


    let steps = ['Enter Phone Number(s)', 'Checklist', 'Upload Latest Bill', 'Sign LOA', 'Order Confirmation'];
    if (props.portingType === 3) {
        steps = ['Enter Phone Number(s)', 'Upload Latest Bill', 'Sign LOA', 'Order Confirmation'];
    }
    const [currentStep, setCurrentStep] = useState(0);
    const [flowStep, setflowStep] = useState(0);
    const [backFlag, setbackFlag] = useState(false);
    const [drafFlag, setdrafFlag] = useState(false);

    const handleNext = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
            setcurrentStepInside(currentStep + 1);

        }
    };
    const handleFinish = () => {
        navigate("/phonenumbers", {
            state: { tab: "tab4" },
        });

        window.location.reload();
    };
    const handleBack = () => {
        if (currentStep > 0) {
            if (props.portingType === 3 && currentStep === 5) {
                setskipFlag(skipFlag === 3 ? 1 : 0);
            }
            setCurrentStep(currentStep - 1);
            setcurrentStepInside(currentStep - 1);
            setflowStep(parseInt(flowStep) - 1);

        }
    };
    const handleReset = () => {
        setCurrentStep(0);
    };

    const stepFieldMap = {
        1: ["enter_num"],
        2: ["review_num"], // adjust if you actually have this section
        3: props.portingType === 3 ? ["acc_info"] : ["assign"],
        4: props.portingType === 3 ? ["service_addr"] : ["acc_info"],
        5: ["service_addr"],
        6: props.portingType === 2 ? ["area_of_service"] : ["notifs_comments"],
        7: ["notifs_comments"]
    };

    const allowedFields = [];
    for (let step = 1; step <= (currentStep === 0 ? currentStepInside : 7); step++) {
        allowedFields.push(...(stepFieldMap[step] || []));
    }
    const handClose = (data) => {
        handleSaveDraft(data, 1);

    }
    const handleSaveDraft = async (data, flag) => {
        console.log("data ::::::::::::: " + JSON.stringify(data));
        // debugger;
        if (Object.keys(formState.dirtyFields).length > 0) {
            const formData = new FormData();

            formData.append(
                "siteid",
                JSON.parse(sessionStorage.getItem("admin_session")).siteid
            );
            formData.append("reqid", parseInt(props.portingType) === 1 ? 91 : parseInt(props.portingType) === 2 ? 95 : 96);
            formData.append("port_type", parseInt(props.portingType));
            formData.append("flow_step", (flag && currentStep === 0) ? parseInt(currentStepInside) : parseInt(flowStep));
            formData.append("save_as_draft", true);
            if (orderID) {
                formData.append("orderid", orderID);
            }
            for (const field of Object.keys(formState.dirtyFields)) {
                if (!allowedFields.includes(field)) continue;
                if (field === "notifs_comments" && props.portingType === 3) continue;
                let modifiedData = {};
                if (formState.dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        for (const subfield of Object.keys(formState.dirtyFields[field])) {
                            if (data[field].hasOwnProperty(subfield)) {
                                modifiedData[subfield] = data[field][subfield];
                            }
                        }
                        if (field === "acc_info" && props.portingType === 2) {
                            modifiedData.porting_num_type = data[field]["porting_num_type"];
                        }
                        if (field === "notifs_comments") {
                            modifiedData.send_email_to_admin =
                                data[field]["send_email_to_admin"];
                        }

                        if (field !== "checklist") {
                            formData.append(field, JSON.stringify(modifiedData));
                        }
                    } else {
                        modifiedData = [...data[field]];
                        formData.append(field, JSON.stringify(modifiedData));
                    }
                }
            }
            if (props.portingType !== 3 && (
                (props.portingType === 1 && flowStep >= 7) ||
                (props.portingType === 2 && flowStep >= 8)
            )) {
                formData.append("checklist", JSON.stringify(data.checklist));
            }
            if (uploadedFiles && uploadedFiles.length > 0 && ((props.portingType === 1 && flowStep >= 8) ||
                (props.portingType === 2 && flowStep >= 9)) || (props.portingType === 3 && flowStep >= 5)) {
                uploadedFiles.forEach((file) => {
                    formData.append("upload_latest_bill", file, file.name);
                });
            }
            if (signLOAUpload && signLOAUpload !== "" &&
                (props.portingType === 2 && flowStep >= 10 && signLOAUpload.name)) {
                // formData.append("sign_loa", signLOAUpload);
                // signLOAUpload.forEach((file) => {
                formData.append("sign_loa", signLOAUpload, signLOAUpload.name);
                // });
            } else if (((props.portingType === 1 && flowStep >= 9) || (props.portingType === 3 && flowStep >= 6)) && formState?.dirtyFields?.sign_loa?.consent_flag !== undefined) {
                formData.append("sign_loa", JSON.stringify(data.sign_loa));
            }
            for (let [key, value] of formData.entries()) {
                console.log(`draft data is ::::::::::: ${key}: ${value}`);
            }
            let saverep = await portingStepsForm(formData, TabIDConstant.TN_TFN_PORT_BTN_SUBLINK);
            console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
            let saverepeMsg = await saverep.json();
            console.log("response of next:::" + JSON.stringify(saverepeMsg));
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                if (flag && flag === 1) {
                    handleFinish();
                } else {
                    setsavedDraftData(data);
                    setSuccessMessage(saverepeMsg.message);
                    if (saverepeMsg?.orderid) {
                        setorderID(saverepeMsg?.orderid);
                    }
                }
            } else {
                if (saverepeMsg.message?.errors) {
                    let tempasserror = [];
                    let temparrerror = [];
                    saverepeMsg.message.errors.forEach((err) => {
                        if (err.position) {
                            if (err.param_name.indexOf("assign") != -1) {
                                tempasserror.push(err);
                            } else if (err.param_name.indexOf("area_of_service") != -1) {
                                temparrerror.push(err);
                            }
                        } else {
                            setError(err.param_name, {
                                type: "server",
                                message: err.message,
                            });
                            const fieldElement = document.querySelector(
                                `input[name="${err.param_name}"]`
                            );
                            if (fieldElement) {
                                fieldElement.focus();
                                fieldElement.scrollIntoView({ behavior: "smooth" });
                            }
                        }
                    });
                    if (tempasserror && tempasserror.length > 0 && currentStep === 3) {
                        setassignedErrors(tempasserror);

                    }
                    if (temparrerror && temparrerror.length > 0 && currentStep === 6) {
                        setAreaErrors(temparrerror);

                    }
                    if (props.setTabSwitchWarn) {
                        props.setTabSwitchWarn(false);
                    }
                } else {
                }
            }
        }
    };

    const currentValues = watch();

    useEffect(() => {
        if (!savedDraftData) {
            setIsChanged(false);
            if (props.setisDraft) {
                props.setisDraft(false);
            }
            return;
        }
        console.log("savedDraftData[key] :::::::::: " + JSON.stringify(savedDraftData));
        console.log("savedDraftData[key] :::::::::: " + JSON.stringify(currentValues));
        // Compare only keys in current form values
        const changed = Object.keys(currentValues).some(
            key => !isEqual(currentValues[key], savedDraftData[key])
        );

        setIsChanged(changed);
        if (props.setisDraft) {
            props.setisDraft(changed);
        }
    }, [currentValues, savedDraftData]);



    console.log("flowStep in main :::::::::::: " + flowStep);
    let stepContent = [
        <>
            <TNLocalStep1 nextPageclick={handleNext}
                portingType={props.portingType}
                register={register}
                watch={watch}
                setValue={setValue}
                clearErrors={clearErrors}
                handleSubmit={handleSubmit}
                formState={formState}
                setError={setError}
                setflowStep={setflowStep}
                flowStep={flowStep}
                setbackFlag={setbackFlag}
                backFlag={backFlag}
                assignedNumbersDetails={assignedNumbersDetails}
                setassignedNumbersDetails={setassignedNumbersDetails}
                setUpdateDestinationObj={setUpdateDestinationObj}
                updateDestinationObj={updateDestinationObj}
                setupdateTempNumObj={setupdateTempNumObj}
                updateTempNumObj={updateTempNumObj}
                areaOfServiceDetails={areaOfServiceDetails}
                setareaOfServiceDetails={setareaOfServiceDetails}
                updateAllArea={updateAllArea}
                setupdateAllArea={setupdateAllArea}
                destinationTypes={destinationTypes}
                setdestinationTypes={setdestinationTypes}
                reset={reset}
                setmaxNumFileUpload={setmaxNumFileUpload}
                settelePhoneList={settelePhoneList}
                drafFlag={drafFlag}
                setdrafFlag={setdrafFlag}
                setorderID={setorderID}
                orderID={orderID}
                setIsloading={setIsloading}
                setSuccessMessage={setSuccessMessage}
                setsavedDraftData={setsavedDraftData}
                isChanged={isChanged}
                currentStep={currentStepInside}
                setcurrentStep={setcurrentStepInside}
                reloadassigned={reloadassigned}
                setreloadassigned={setreloadassigned}
                portingNumbers={portingNumbers}
                setportingNumbers={setportingNumbers}
                assignedErrors={assignedErrors}
                areaErrors={areaErrors}
                setassignedErrors={setassignedErrors}
                setAreaErrors={setAreaErrors}
            />
        </>,

        // Step - 2 
        <>
            <TNCheckList
                nextPageclick={handleNext}
                handleBack={handleBack}
                currentStep={currentStep}
                register={register}
                watch={watch}
                setValue={setValue}
                clearErrors={clearErrors}
                handleSubmit={handleSubmit}
                formState={formState}
                setError={setError}
                portingType={props.portingType}
                setflowStep={setflowStep}
                flowStep={flowStep}
                setbackFlag={setbackFlag}
                setorderID={setorderID}
                setSuccessMessage={setSuccessMessage}
                setsavedDraftData={setsavedDraftData}
                isChanged={isChanged}
                orderID={orderID}
            />

        </>,
        <>
            <UPloadCopyOfBill
                handleNext={handleNext}
                currentStep={currentStep}
                handleBack={handleBack}
                uploadedFiles={uploadedFiles}
                setUploadedFiles={setUploadedFiles}
                maxNumFileUpload={maxNumFileUpload}
                setflowStep={setflowStep}
                nextPageclick={handleNext}
                flowStep={flowStep}
                handleSubmit={handleSubmit}
                formState={formState}
                setError={setError}
                portingType={props.portingType}
                setUploadedOldFiles={setUploadedOldFiles}
                uploadedOldFiles={uploadedOldFiles}
                selectedFiles={selectedFiles}
                setselectedFiles={setselectedFiles}
                setbackFlag={setbackFlag}
                setorderID={setorderID}
                setSuccessMessage={setSuccessMessage}
                setsavedDraftData={setsavedDraftData}
                isChanged={isChanged}
                orderID={orderID}
                setdeletedFiles={setdeletedFiles}
                deletedFiles={deletedFiles}

            />
        </>,
        <>
            {parseInt(props.portingType) === 1 ? (
                <SignLOA
                    watch={watch}
                    handleNext={handleNext}
                    currentStep={currentStep}
                    handleBack={handleBack}
                    telePhoneList={telePhoneList}
                    setValue={setValue}
                    portingType={parseInt(props.portingType)}
                    setflowStep={setflowStep}
                    nextPageclick={handleNext}
                    flowStep={flowStep}
                    handleSubmit={handleSubmit}
                    uploadedFiles={uploadedFiles}
                    uploadedOldFiles={uploadedOldFiles}
                    formState={formState}
                    setorderID={setorderID}
                    handleSaveDraft={handleSaveDraft}
                    orderID={orderID}
                    setIsloading={setIsloading}
                />
            ) : (
                <TFNSignLOA
                    watch={watch}
                    handleNext={handleNext}
                    currentStep={currentStep}
                    handleBack={handleBack}
                    telePhoneList={telePhoneList}
                    setValue={setValue}
                    portingType={parseInt(props.portingType)}
                    setflowStep={setflowStep}
                    nextPageclick={handleNext}
                    flowStep={flowStep}
                    handleSubmit={handleSubmit}
                    uploadedFiles={uploadedFiles}
                    formState={formState}
                    signLOAUpload={signLOAUpload}
                    setsignLOAUpload={setsignLOAUpload}
                    uploadedOldFiles={uploadedOldFiles}
                    handleSaveDraft={handleSaveDraft}
                    orderID={orderID}
                    setIsloading={setIsloading}
                />
            )}

        </>,
        <>
            <div className="pb-3 container h-100 finish-page-container LOA-container">
                <p className="fw-bold">Thank You! We will now process your transfer order request {orderID} for the following telephone numbers.</p>
                <p className='fw-bold d-block'>
                    Numbers:
                </p>
                <div className="p-2 border border-2  rounded-4" style={{ maxHeight: "calc(100vh - 370px)", overflowY: "auto" }}>

                    <div className='d-flex flex-wrap gap-1 '>
                        {telePhoneList.map((telephone) => (
                            <MDBChip scope="row">{formattedNumber(telephone + "")}</MDBChip>
                        ))}
                    </div>
                </div>
                <p>
                    To check your order details, click Order Number corresponding to the order under
                    <b> Admin Dashboard → Phone System → Phone Numbers → Number Porting and Validation Status. Do not submit an order to cancel the current service until the port is successfully completed.</b>
                </p>
                <div className="routing-border m-0 p-0 py-2"></div>

                <div className='mt-3'>
                    <strong>Transfer Time</strong>
                    <p>Transferring typically takes between 7-10 business days(but occasionally up to four weeks), and depends on your current telephone service provider.</p>
                </div>
                <div className='mt-3'>
                    <strong>Get Notified</strong>
                    <p>We will notify you and help you resubmit your case if your current telephone service provider denies the transfer. Otherwise, we will send you an email notification once the process is complete, or when your current telephone service provider updates us with more information.</p>
                </div>
                <div className='mt-3'>
                    <strong>View Status</strong>
                    <p>You can find the current status of your number transfer request under Admin Dashboard → Phone System → Phone Numbers → Number Porting and Validation Status.</p>
                </div>
                <div className='mt-3'>
                    <strong>To ensure the proper handling of your number transfer</strong>
                    <p>Do not place an order to disconnect your service with your current telephone service provider until the phone number transfer completes and is in use with {streamsProductName} for at least one week.</p>
                </div>
                <div className='mt-3'>
                    <strong>To ensure the proper handling of your number transfer</strong>
                    <p>
                        If you have any question, contact us at <b>(800) 619-3688</b> and follow the prompts to reach LNP admin or you can drop an email to <b>carriernotifications@panterranetworks.com</b>.
                    </p>
                </div>
            </div>
            <MDBModalFooter className="d-flex justify-content-between">
                {/* <MDBBtn color='secondary'>
                    Save to Draft
                </MDBBtn> */}
                <div className="text-end float-end w-100">

                    {/* <MDBBtn color='secondary' className='me-2' onClick={handleBack} disabled={currentStep === 0}>
                        Back
                    </MDBBtn> */}
                    <MDBBtn onClick={handleFinish}>Finish</MDBBtn>
                </div>
            </MDBModalFooter>
        </>
    ];

    if (props.portingType === 3) {
        stepContent = [
            <>
                <TNLocalStep1
                    nextPageclick={handleNext}
                    portingType={props.portingType}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    handleSubmit={handleSubmit}
                    formState={formState}
                    setError={setError}
                    setflowStep={setflowStep}
                    flowStep={flowStep}
                    setbackFlag={setbackFlag}
                    backFlag={backFlag}
                    assignedNumbersDetails={assignedNumbersDetails}
                    setassignedNumbersDetails={setassignedNumbersDetails}
                    setUpdateDestinationObj={setUpdateDestinationObj}
                    updateDestinationObj={updateDestinationObj}
                    setupdateTempNumObj={setupdateTempNumObj}
                    updateTempNumObj={updateTempNumObj}
                    areaOfServiceDetails={areaOfServiceDetails}
                    setareaOfServiceDetails={setareaOfServiceDetails}
                    updateAllArea={updateAllArea}
                    setupdateAllArea={setupdateAllArea}
                    destinationTypes={destinationTypes}
                    setdestinationTypes={setdestinationTypes}
                    reset={reset}
                    setmaxNumFileUpload={setmaxNumFileUpload}
                    settelePhoneList={settelePhoneList}
                    drafFlag={drafFlag}
                    setdrafFlag={setdrafFlag}
                    setorderID={setorderID}
                    orderID={orderID}
                    setskipFlag={setskipFlag}
                    skipFlag={skipFlag}
                    resetField={resetField}
                    skipfields={skipfields}
                    setIsloading={setIsloading}
                    setSuccessMessage={setSuccessMessage}
                    setsavedDraftData={setsavedDraftData}
                    isChanged={isChanged}
                    currentStep={currentStepInside}
                    setcurrentStep={setcurrentStepInside}
                    reloadassigned={reloadassigned}
                    setreloadassigned={setreloadassigned}
                    portingNumbers={portingNumbers}
                    setportingNumbers={setportingNumbers}
                    assignedErrors={assignedErrors}
                    areaErrors={areaErrors}
                    setassignedErrors={setassignedErrors}
                    setAreaErrors={setAreaErrors}
                />
            </>,

            // Step - 2 
            <>
                <UPloadCopyOfBill
                    handleNext={handleNext}
                    currentStep={currentStep}
                    handleBack={handleBack}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    maxNumFileUpload={maxNumFileUpload}
                    setflowStep={setflowStep}
                    nextPageclick={handleNext}
                    flowStep={flowStep}
                    handleSubmit={handleSubmit}
                    formState={formState}
                    setError={setError}
                    portingType={props.portingType}
                    setUploadedOldFiles={setUploadedOldFiles}
                    uploadedOldFiles={uploadedOldFiles}
                    selectedFiles={selectedFiles}
                    setselectedFiles={setselectedFiles}
                    setbackFlag={setbackFlag}
                    setorderID={setorderID}
                    setSuccessMessage={setSuccessMessage}
                    setsavedDraftData={setsavedDraftData}
                    isChanged={isChanged}
                    orderID={orderID}
                />
            </>,
            <>

                <SignLOA
                    watch={watch}
                    handleNext={handleNext}
                    currentStep={currentStep}
                    handleBack={handleBack}
                    telePhoneList={telePhoneList}
                    setValue={setValue}
                    portingType={parseInt(props.portingType)}
                    setflowStep={setflowStep}
                    nextPageclick={handleNext}
                    flowStep={flowStep}
                    handleSubmit={handleSubmit}
                    uploadedFiles={uploadedFiles}
                    uploadedOldFiles={uploadedOldFiles}
                    formState={formState}
                    setorderID={setorderID}
                    handleSaveDraft={handleSaveDraft}
                    setIsloading={setIsloading}
                    orderID={orderID}
                    skipFlag={skipFlag}

                />
            </>,



            <>
                <div className='d-flex flex-column w-100 container ' style={{ height: 'calc(100vh - 200px)' }}>
                    <div style={{ flex: 1, overflowY: 'auto' }}>


                        <div className='p-5 border border-2 rounded-4'>

                            <p className='mb-2'>

                                Order Confirmation!!

                            </p>

                            <p className='mb-2'>

                                Thank You!
                            </p>
                            <p className='mb-2'>

                                Your telephone number validation order for Order Number <b>{orderID}</b> has been submitted successfully.
                            </p>
                            <p className='mb-2'>
                                You can use validated Telephone Number(s) for caller ID purposes.
                            </p>

                        </div>


                    </div>
                </div>







                {/* <div className="pb-3 container h-100" style={{ overflowY: "auto", maxHeight: "calc(100vh - 190px)" }}>
                    <p className="fw-bold">Thank You! We will now process your transfer order request {orderID} for the following telephone numbers.</p>
                  

                    <div className="d-flex flex-wrap gap-2 p-2 border border-2  rounded-4" style={{ maxHeight: "calc(100vh - 370px)", overflowY: "auto" }}>
                        <p className='fw-bold d-block'>
                            Numbers:
                        </p>
                        {telePhoneList.map((telephone) => (
                            <MDBChip scope="row">{formattedNumber(telephone + "")}</MDBChip>
                        ))}
                    </div>


                    <p>
                        To check your order details, click Order Number corresponding to the order under
                        <b> Admin Dashboard → Phone System → Phone Numbers → Number Porting Porting and Validation Status. Do not submit an order to cancel the current service until the port is successfully completed.</b>
                    </p>
                    <div className="routing-border m-0 p-0 py-2"></div>

                    <div className='mt-3'>
                        <strong>Transfer Time</strong>
                        <p>Transferring typically takes between 7-10 business days(but occasionally up to four weeks), and depends on your current telephone service provider.</p>
                    </div>
                    <div className='mt-3'>
                        <strong>Get Notified</strong>
                        <p>We will notify you and help you resubmit your case if your current telephone service provider denies the transfer. Otherwise, we will send you an email notification once the process is complete, or when your current telephone service provider updates us with more information.</p>
                    </div>
                    <div className='mt-3'>
                        <strong>View Status</strong>
                        <p>You can find the current status of your number transfer request under Admin Dashboard → Phone System → Phone Numbers → Number Porting and Validation Status.</p>
                    </div>
                    <div className='mt-3'>
                        <strong>To ensure the proper handling of your number transfer</strong>
                        <p>Do not place an order to disconnect your service with your current telephone service provider until the phone number transfer completes and is in use with Streams for at least one week.</p>
                    </div>
                    <div className='mt-3'>
                        <strong>To ensure the proper handling of your number transfer</strong>
                        <p>
                            If you have any question, contact us at <b>(800) 619-3688</b> and follow the prompts to reach LNP admin or you can drop an email to <b>carriernotifications@panterranetworks.com</b>.
                        </p>
                    </div>
                </div> */}
                <MDBModalFooter className="d-flex justify-content-between">

                    <div className="text-end float-end w-100">

                        <MDBBtn onClick={(e) => {
                            e.preventDefault();
                            handleFinsihed();
                        }}>Finish</MDBBtn>
                    </div>
                </MDBModalFooter>
            </>
        ];
    }

    useEffect(() => {
        if (props.draftInfo && Object.keys(props.draftInfo).length > 0) {
            setTheDraftValue();
        }

    }, [props.draftInfo]);

    function setTheDraftValue() {
        try {
            // debugger;
            setTheAllParanValues(props.draftInfo);
            settelePhoneList(props.draftInfo?.validated_numbers);
            // let assigned = props.draftInfo?.assign ?? [];

            const { assigned, destObj, numObj } = (props.draftInfo?.assign ?? []).reduce((acc, detail) => {
                acc.assigned.push({
                    number: detail.number,
                    // The backend's draft record stores dest/dest_type as an
                    // integer column (0 when unassigned, a real numeric id
                    // otherwise), but the rest of this flow (the Destination
                    // Type/Destination <select>s, the submitted "assign"
                    // payload) treats "" as the unassigned sentinel and
                    // expects assigned values as strings (matching what the
                    // <select>'s onChange already sends). Same normalization
                    // setTheAllParanValues already applies a few lines down
                    // when populating the "assign" form field from this same
                    // draft data, kept consistent here too.
                    dest: detail.dest && detail.dest != 0 ? detail.dest + "" : "",
                    dest_type: detail.dest_type && detail.dest_type != 0 ? detail.dest_type + "" : "",
                    temp_num: detail.temp_num,
                    destinations: detail?.misc?.dest ?? [],
                    tempNumber: (detail?.misc?.temp_num ?? []).map((entry) => ({
                        text: entry,
                        value: entry,
                    })),
                });

                if (detail.dest && detail.dest !== "") {
                    acc.destObj.push({ [detail.dest]: detail?.misc?.dest ?? [] });
                }

                if (detail.temp_num && detail.temp_num !== "") {
                    acc.numObj.push({ [detail.temp_num]: detail?.misc?.temp_num ?? [] });
                }

                return acc;
            }, { assigned: [], destObj: [], numObj: [] });

            setassignedNumbersDetails(assigned ?? []);
            setUpdateDestinationObj(destObj ?? []);
            setupdateTempNumObj(numObj ?? []);
            setreloadassigned(true);

            let assignedNumber = (props.draftInfo?.area_of_service) ?? [];
            assignedNumber = Object.entries(assignedNumber).map(([tfn_num, area]) => ({
                tfn_num: Number(tfn_num),
                area_of_service: area
            }));
            assignedNumber = assignedNumber.map((number) => ({ tfn_num: parseInt(number.tfn_num), area_of_service: number.area_of_service }));
            setareaOfServiceDetails(assignedNumber ?? []);
            setdestinationTypes(props.draftInfo?.dest_type ?? []);
            setUploadedOldFiles(props.draftInfo?.upload_latest_bill ?? []);
            if (props.draftInfo?.flow_step) {
                const flowsteps = props.draftInfo?.flow_step ? parseInt(props.draftInfo?.flow_step) : 0;
                if (flowsteps > 0) {
                    setdrafFlag(true);
                }
                setflowStep(flowsteps);
                let currstep = 0
                if (props.portingType === 1) {
                    currstep = flowsteps === 7 ? 1 : flowsteps === 8 ? 2 : flowsteps === 9 ? 3 : flowsteps === 10 ? 4 : 0

                }
                if (props.portingType === 2) {
                    currstep = flowsteps === 8 ? 1 : flowsteps === 9 ? 2 : flowsteps === 10 ? 3 : flowsteps === 11 ? 4 : 0

                }
                if (props.portingType === 3) {
                    currstep = flowsteps === 5 ? 1 : flowsteps === 6 ? 2 : flowsteps === 7 ? 3 : 0

                }
                setCurrentStep(currstep);
                setcurrentStepInside(currstep);
            }

            if (props.portingType === 2) {
                setsignLOAUpload((props.draftInfo?.sign_loa?.file_name && props.draftInfo?.sign_loa?.file_name !== "") ? props.draftInfo?.sign_loa : "");
            }
        } catch (error) {

        }
    }
    useEffect(() => {
        if ((props.portingType === 3 && currentStep === 3) || ((props.portingType === 2 || props.portingType === 1) && currentStep === 4)) {
            props.setcloseFlag(true);
        } else {
            props.setcloseFlag(false);
        }

    }, [currentStep])

    function setTheAllParanValues(info) {
        console.log("json data :::::::::::::draft ::::: " + JSON.stringify(info));

        setValue("enter_num.number", info?.validated_numbers ? info?.validated_numbers.join(', ') : "", { shouldDirty: true });
        setValue("enter_num.ddd", info?.ddd ?? "", { shouldDirty: true });

        // setValue("acc_info.title", info?.acc_info?.title ?? "", { shouldDirty: true });
        setValue("acc_info.acc_num", info?.acc_info?.acc_num ?? "", { shouldDirty: true });
        setValue("acc_info.acc_pin", info?.acc_info?.acc_pin ?? "", { shouldDirty: true });
        setValue("acc_info.last_name", info?.acc_info?.last_name ?? "", { shouldDirty: true });
        setValue("acc_info.first_name", info?.acc_info?.first_name ?? "", { shouldDirty: true });
        setValue("acc_info.company_name", info?.acc_info?.company_name ?? "", { shouldDirty: true });
        setValue("acc_info.bill_tele_num", info?.acc_info?.bill_tele_num ? parseInt(info?.acc_info?.bill_tele_num) : "", { shouldDirty: true });
        setValue("acc_info.is_mobile_num", info?.acc_info?.is_mobile_tn !== undefined ? info.acc_info.is_mobile_tn : false, { shouldDirty: true });
        setValue("acc_info.caller_id_name", info?.acc_info?.caller_id_name ?? "", { shouldDirty: true });
        setValue("acc_info.curr_carrier_name", info?.acc_info?.curr_carrier_name ?? "", { shouldDirty: true });
        // setValue("acc_info.name_listed_on_acc", info?.acc_info?.name_listed_on_acc ?? "", { shouldDirty: true });
        setValue("acc_info.porting_num_type", info?.acc_info?.accinfo_type ?? 1, { shouldDirty: true });
        setValue("acc_info.contact_title", info?.acc_info?.contact_title ?? "", { shouldDirty: true });
        setValue("acc_info.authorized_customer_fax", info?.acc_info?.authorized_customer_fax ?? "", { shouldDirty: true });

        setValue("service_addr.zip", info?.service_addr?.zip ?? "", { shouldDirty: true });
        setValue("service_addr.city", info?.service_addr?.city ?? "", { shouldDirty: true });
        setValue("service_addr.state", info?.service_addr?.state ?? "", { shouldDirty: true });
        setValue("service_addr.suite", info?.service_addr?.suite ?? "", { shouldDirty: true });
        setValue("service_addr.floor_num", info?.service_addr?.floor_num ?? "", { shouldDirty: true });
        setValue("service_addr.street_num", info?.service_addr?.street_num ?? "", { shouldDirty: true });
        setValue("service_addr.street_name", info?.service_addr?.street_name ?? "", { shouldDirty: true });
        setValue("service_addr.carrier_pin", info?.service_addr?.carrier_pin ?? "", { shouldDirty: true });
        setValue("service_addr.carrier_name", info?.service_addr?.carrier_name ?? "", { shouldDirty: true });
        setValue("service_addr.carrier_acc_num", info?.service_addr?.carrier_acc_num ?? "", { shouldDirty: true });
        // setValue("service_addr.acc_btn", info?.service_addr?.acc_btn ?? "", { shouldDirty: true });

        setValue("notifs_comments.email", info?.notifs_comments?.email ?? "", { shouldDirty: true });
        setValue("notifs_comments.comments", info?.notifs_comments?.comments ?? "", { shouldDirty: true });
        setValue("notifs_comments.contact_ph_num", info?.notifs_comments?.contact_ph_num ? parseInt(info?.notifs_comments?.contact_ph_num) : "", { shouldDirty: true });
        setValue("notifs_comments.send_email_to_admin", info?.notifs_comments?.send_email_to_admin ?? true, { shouldDirty: true });

        setValue("checklist.check_ans_one", info?.checklist?.check_ans_one !== undefined ? info.checklist.check_ans_one : true, { shouldDirty: true });
        setValue("checklist.check_ans_two", info?.checklist?.check_ans_two !== undefined ? info.checklist.check_ans_two : true, { shouldDirty: true });
        setValue("checklist.check_ans_three", info?.checklist?.check_ans_three !== undefined ? info.checklist.check_ans_three : true, { shouldDirty: true });
        setValue("checklist.check_ans_four", info?.checklist?.check_ans_four !== undefined ? info.checklist.check_ans_four : true, { shouldDirty: true });
        setValue("checklist.check_ans_five", info?.checklist?.check_ans_five !== undefined ? info.checklist.check_ans_five : true, { shouldDirty: true });

        if (props.portingType !== 2) {
            setValue("sign_loa.consent_flag", props.portingType !== 2
                ? info?.sign_loa?.consent_flag !== undefined ? info.sign_loa.consent_flag : false
                : false, { shouldDirty: true });
        }

        if (info?.assign && info?.assign?.length > 0) {
            const assigned = info?.assign.map((detail) => ({ number: detail.number, dest: detail.dest && detail.dest != 0 ? detail.dest + "" : "", dest_type: detail.dest_type && detail.dest_type != 0 ? detail.dest_type + "" : "", temp_num: detail.temp_num ?? [] }));
            setValue("assign", assigned ?? [], { shouldDirty: true });
        }

        if (info?.area_of_service) {
            let assignedNumber = (props.draftInfo?.area_of_service) ?? [];
            assignedNumber = Object.entries(assignedNumber).map(([tfn_num, area]) => ({
                tfn_num: Number(tfn_num),
                area_of_service: area
            }));
            assignedNumber = assignedNumber.map((number) => ({ tfn_num: parseInt(number.tfn_num), area_of_service: number.area_of_service }));
            setValue("area_of_service", assignedNumber ?? [], { shouldDirty: true });
        }

        setportingNumbers(info?.validated_numbers ? info?.validated_numbers : []);
        // debugger;
        if (info?.upload_latest_bill && info?.upload_latest_bill.length > 0) {
            setUploadedOldFiles(info?.upload_latest_bill);
        }
        if (info?.orderid) {
            setorderID(info?.orderid);
        }
        setsavedDraftData({
            enter_num: {
                ddd: info?.ddd ?? "",
                number: info?.validated_numbers ? info?.validated_numbers.join(', ') : "",
            },
            assign: info?.assign && info?.assign.length > 0
                ? info.assign.map(detail => ({
                    number: detail.number,
                    dest: detail.dest && detail.dest != 0 ? detail.dest + "" : "",
                    dest_type: detail.dest_type && detail.dest_type != 0 ? detail.dest_type + "" : "",
                    temp_num: detail.temp_num ?? [],
                }))
                : [],
            acc_info: {
                // title: info?.acc_info?.title ?? "",
                acc_num: info?.acc_info?.acc_num ?? "",
                acc_pin: info?.acc_info?.acc_pin ?? "",
                last_name: info?.acc_info?.last_name ?? "",
                first_name: info?.acc_info?.first_name ?? "",
                company_name: info?.acc_info?.company_name ?? "",
                bill_tele_num: info?.acc_info?.bill_tele_num ? parseInt(info?.acc_info?.bill_tele_num) : "",
                is_mobile_num: info?.acc_info?.is_mobile_tn !== undefined ? info.acc_info.is_mobile_tn : false,
                caller_id_name: info?.acc_info?.caller_id_name ?? "",
                curr_carrier_name: info?.acc_info?.curr_carrier_name ?? "",
                // name_listed_on_acc: info?.acc_info?.name_listed_on_acc ?? "",
                porting_num_type: info?.acc_info?.accinfo_type ?? 1,
                contact_title: info?.acc_info?.contact_title ?? "",
                authorized_customer_fax: info?.acc_info?.authorized_customer_fax ?? "",
            },
            service_addr: {
                zip: info?.service_addr?.zip ?? "",
                city: info?.service_addr?.city ?? "",
                state: info?.service_addr?.state ?? "",
                suite: info?.service_addr?.suite ?? "",
                floor_num: info?.service_addr?.floor_num ?? "",
                street_num: info?.service_addr?.street_num ?? "",
                street_name: info?.service_addr?.street_name ?? "",
                carrier_pin: info?.service_addr?.carrier_pin ?? "",
                carrier_name: info?.service_addr?.carrier_name ?? "",
                carrier_acc_num: info?.service_addr?.carrier_acc_num ?? "",
                // acc_btn: info?.service_addr?.acc_btn ?? "",
            },
            area_of_service: info?.area_of_service
                ? Object.entries(info.area_of_service).map(([tfn_num, area]) => ({
                    tfn_num: Number(tfn_num),
                    area_of_service: area
                }))
                : [],
            notifs_comments: {
                email: info?.notifs_comments?.email ?? "",
                comments: info?.notifs_comments?.comments ?? "",
                contact_ph_num: info?.notifs_comments?.contact_ph_num ? parseInt(info?.notifs_comments?.contact_ph_num) : "",
                send_email_to_admin: info?.notifs_comments?.send_email_to_admin ?? true,
            },
            checklist: {
                check_ans_one: info?.checklist?.check_ans_one !== undefined ? info.checklist.check_ans_one : true,
                check_ans_two: info?.checklist?.check_ans_two !== undefined ? info.checklist.check_ans_two : true,
                check_ans_three: info?.checklist?.check_ans_three !== undefined ? info.checklist.check_ans_three : true,
                check_ans_four: info?.checklist?.check_ans_four !== undefined ? info.checklist.check_ans_four : true,
                check_ans_five: info?.checklist?.check_ans_five !== undefined ? info.checklist.check_ans_five : true,
            },
            sign_loa: {
                consent_flag: props.portingType !== 2
                    ? info?.sign_loa?.consent_flag !== undefined ? info.sign_loa.consent_flag : false
                    : false
            }
        });
    }

    const handleFinsihed = () => {
        navigate("/phonenumbers", {
            state: { tab: "tab4" },
        });
        window.location.reload();
    }


    props.setportingSave(
        Object.keys(formState.dirtyFields).length === 0 ? false : true);

    return (
        <>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            <MDBModal
                open={props.TabSwitchWarn}
                setShow={props.setTabSwitchWarn}
                tabIndex="-1"
            >
                <MDBModalDialog>
                    <MDBModalContent className="small-popup h-auto">
                        <MDBModalHeader>
                            <MDBModalTitle>
                                {t("Warning")}
                            </MDBModalTitle>
                            <MDBBtn
                                className="btn-close"
                                color="none"
                                onClick={(e) => { e.preventDefault(); props.setTabSwitchWarn(false); }}
                            ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                                <MDBIcon fas icon="question-circle" className="me-3 fs-5 mt-1" color="warning" />
                                <div>
                                    You have some unsaved data. Click Save button to save changes.
                                    {/* You have updates that haven’t been saved. Click <strong>Discard</strong> Changes to remove them or <strong>Cancel</strong> to keep editing. */}
                                </div>
                            </div>
                        </MDBModalBody>
                        <MDBModalFooter className="d-flex justify-content-between">
                            <MDBBtn color="secondary" onClick={(e) => {
                                reset();
                                props.setCentredModal2(false);
                                handleFinish();
                            }}>Discard Changes</MDBBtn>
                            <div className="d-flex">
                                <MDBBtn color="secondary" className="me-2" onClick={(e) => { e.preventDefault(); props.setTabSwitchWarn(false); }}>
                                    {t("cancel")}
                                </MDBBtn>
                                {isChanged && (
                                    <MDBBtn onClick={(e) => { e.preventDefault(); handleSubmit(handClose)(); }}>{t("save")}</MDBBtn>
                                )}
                            </div>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            <div className="stepper-container">
                <div className="stepper">
                    {steps.map((step, index) => (
                        <>
                            <div
                                key={index}
                                className={`step ${index <= currentStep ? 'active' : ''}`}
                            >
                                <div className="step-number">{index + 1}</div>
                                <div className="step-label ms-2">{step}</div>
                            </div>
                        </>
                    ))}
                </div>

                <div className="stepper-content">
                    {stepContent[currentStep]}
                </div>
            </div>
            {successMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setSuccessMessage("")}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{successMessage}</span>
                </MDBAlert>
            )}
        </>
    )
}
export default TNLocalNumber